export function handleFullFunnelRedirect() {
  const searchParams = new URL(window.location.href).searchParams.toString();
  const params = new URLSearchParams(searchParams);

  if (!params.has('opf')) {
    return {
      fullFunnelCheckURL: '',
      isFullFunnelOrigin: false,
      partnerSlug: '',
    };
  }

  const partnerSlug = params.get('opf');
  // params.delete('opf');

  const hasParams = params?.toString()?.length > 0;
  return {
    fullFunnelCheckURL: `/analisando-oferta${hasParams && `?${params.toString()}`}`,
    isFullFunnelOrigin: true,
    partnerSlug,
  };
}
